import router from '@/router';
import openModal from '@/components/modal';
import recognition from '@/auth/recognition';
import isGuestRoute from '@/auth/isGuestRoute';
import AgreementModal from './AgreementModal.vue';
import { hasAgreedTerms } from '.';

async function showPopup(clientId: number): Promise<void> {
  return new Promise((resolve) => {
    const props = { clientId };
    openModal(AgreementModal, props).onOk(resolve);
  });
}

function getClientId(): number|null {
  if (!recognition.isClient()) return null;
  return recognition.getAccountId();
}

async function check(): Promise<void> {
  const clientId = getClientId();
  if (!clientId) return Promise.resolve();
  const hasAgreed = await hasAgreedTerms(clientId);
  if (hasAgreed) return Promise.resolve();
  return showPopup(clientId);
}

export function registerPopup() {
  router.beforeEach((to, from, next) => {
    if (isGuestRoute(to.path)) {
      next();
      return;
    }
    check().then(() => {
      next();
    });
  });
}
